"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _luxon = require("luxon");

var _concat = _interopRequireDefault(require("lodash/concat"));

var _errormessages = _interopRequireDefault(require("./helpers/errormessages"));

var _getucnid = _interopRequireDefault(require("./helpers/getucnid"));

var _getusercontext = _interopRequireDefault(require("./helpers/getusercontext"));

var _customizr = require("./services/customizr");

var _uuid = require("uuid");

var TIME_TO_LIVE_IN_DAYS = 30;

var formatTTL = function formatTTL(dateTime) {
  return dateTime.plus({
    days: TIME_TO_LIVE_IN_DAYS
  }).toHTTP();
};
/**
 * Given an origin, destination and payload, parses the url to retrieve the context (or create a new context), then appends the payload to the context
 * @param {object} userData - the user data to add to the context
 * @param {string} origin - the origin url (optional, if not specified, detected from browser)
 * @param {string} destination - the destination url
 * @param {string} accessToken - the access token of the user
 * @returns the newly updated destination url and the context if navigation was successful, the error object if not
 */


var navigate = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var userData, origin, destination, accessToken, _getUcnId, originUrl, ucnId, isValidUrl, _yield$getUserContext, previousContext, error, newPayload, updatedContext, _timeToLive, contextId, createdAt, updatedAt, timeToLive, newContext;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            userData = _ref.userData, origin = _ref.origin, destination = _ref.destination, accessToken = _ref.accessToken;
            _getUcnId = (0, _getucnid["default"])({
              url: origin
            }), originUrl = _getUcnId.originUrl, ucnId = _getUcnId.ucnId, isValidUrl = _getUcnId.isValidUrl; // If the origin url isn't valid, return an error.

            if (isValidUrl) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", {
              error: {
                message: _errormessages["default"].originUrlNotValid
              }
            });

          case 4:
            _context.prev = 4;
            new URL(destination);
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](4);
            return _context.abrupt("return", {
              error: {
                message: _errormessages["default"].destinationUrlNotValid
              }
            });

          case 11:
            if (!ucnId) {
              _context.next = 25;
              break;
            }

            _context.next = 14;
            return (0, _getusercontext["default"])({
              ucnId: ucnId,
              accessToken: accessToken
            });

          case 14:
            _yield$getUserContext = _context.sent;
            previousContext = _yield$getUserContext.context;
            error = _yield$getUserContext.error;

            if (!error) {
              _context.next = 19;
              break;
            }

            return _context.abrupt("return", {
              contextId: ucnId,
              error: error
            });

          case 19:
            newPayload = _createNewPayload({
              origin: originUrl,
              destination: destination,
              body: userData
            }); // create new context by appending the new payload to the payloads field

            updatedContext = {
              contextId: previousContext.contextId,
              createdAt: previousContext.createdAt,
              updatedAt: _luxon.DateTime.utc(),
              payloads: (0, _concat["default"])(previousContext.payloads, newPayload)
            }; // update the TTL to 30 days after the updated timestamp of the context
            // that way, if the context is idle for 30 days, this will get deleted

            _timeToLive = formatTTL(updatedContext.updatedAt);
            _context.next = 24;
            return _updateContext({
              accessToken: accessToken,
              contextId: ucnId,
              context: updatedContext,
              timeToLive: _timeToLive,
              destination: destination
            });

          case 24:
            return _context.abrupt("return", _context.sent);

          case 25:
            // if context does not already exist, create a new context from scratch
            contextId = (0, _uuid.v4)();
            createdAt = _luxon.DateTime.utc(); // set updatedAt to equal createdAt since this is a newly created context

            updatedAt = createdAt;
            timeToLive = formatTTL(createdAt);
            newContext = {
              contextId: contextId,
              createdAt: createdAt,
              updatedAt: updatedAt,
              payloads: [_createNewPayload({
                origin: originUrl,
                destination: destination,
                body: userData,
                createdAt: createdAt
              })]
            };
            _context.next = 32;
            return _updateContext({
              accessToken: accessToken,
              contextId: contextId,
              context: newContext,
              timeToLive: timeToLive,
              destination: destination
            });

          case 32:
            return _context.abrupt("return", _context.sent);

          case 33:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 8]]);
  }));

  return function navigate(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var _createNewPayload = function _createNewPayload(_ref3) {
  var origin = _ref3.origin,
      destination = _ref3.destination,
      body = _ref3.body,
      _ref3$createdAt = _ref3.createdAt,
      createdAt = _ref3$createdAt === void 0 ? _luxon.DateTime.utc() : _ref3$createdAt;
  return {
    payloadId: (0, _uuid.v4)(),
    connection: {
      origin: origin,
      destination: destination
    },
    createdAt: createdAt,
    body: body
  };
};

var _updateContext = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref4) {
    var accessToken, contextId, context, timeToLive, destination, updatedContext, destinationUrl, status, errorToSurface;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            accessToken = _ref4.accessToken, contextId = _ref4.contextId, context = _ref4.context, timeToLive = _ref4.timeToLive, destination = _ref4.destination;
            _context2.prev = 1;
            _context2.next = 4;
            return (0, _customizr.updateUserSettings)({
              accessToken: accessToken,
              contextId: contextId,
              context: context,
              timeToLive: timeToLive
            });

          case 4:
            updatedContext = _context2.sent;
            destinationUrl = new URL(destination);
            destinationUrl.searchParams.append("ucnId", contextId);
            return _context2.abrupt("return", {
              contextId: contextId,
              destination: destinationUrl.toString(),
              context: updatedContext
            });

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](1);
            status = _context2.t0.response.status;
            errorToSurface = {
              message: "",
              serverError: _context2.t0
            };
            _context2.t1 = status;
            _context2.next = _context2.t1 === 401 ? 17 : _context2.t1 === 403 ? 19 : _context2.t1 === 404 ? 21 : 23;
            break;

          case 17:
            errorToSurface.message = _errormessages["default"].unauthorized;
            return _context2.abrupt("break", 24);

          case 19:
            errorToSurface.message = _errormessages["default"].forbidden.update;
            return _context2.abrupt("break", 24);

          case 21:
            errorToSurface.message = _errormessages["default"].notFound;
            return _context2.abrupt("break", 24);

          case 23:
            errorToSurface.message = "".concat(_errormessages["default"].serviceError.update, " ").concat(_errormessages["default"].contactMessage);

          case 24:
            return _context2.abrupt("return", {
              contextId: contextId,
              error: errorToSurface
            });

          case 25:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 10]]);
  }));

  return function _updateContext(_x2) {
    return _ref5.apply(this, arguments);
  };
}();

var _default = navigate;
exports["default"] = _default;